import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './agenda-item.types';
import * as constants from './agenda-item.constants';

export const agendaItemReducer = generateResourceReducer<types.IAgendaItem>({
  STORE: constants.STORE_AGENDA_ITEM,
  CLEAR: constants.CLEAR_AGENDA_ITEM,
});
